//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { ClientBase } from "../ClientBase";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ClassificationClient extends ClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  classificationGetClassifications(body: GetClassificationsRequest | undefined): Promise<ClassificationDto[]> {
    let url_ = this.baseUrl + "/v1/Classification/GetClassifications";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processClassificationGetClassifications(_response);
      });
  }

  protected processClassificationGetClassifications(response: Response): Promise<ClassificationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClassificationDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  classificationGetClassificationsTree(body: GetClassificationsRequest | undefined): Promise<ClassificationTreeDto[]> {
    let url_ = this.baseUrl + "/v1/Classification/GetClassificationsTree";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processClassificationGetClassificationsTree(_response);
      });
  }

  protected processClassificationGetClassificationsTree(response: Response): Promise<ClassificationTreeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClassificationTreeDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationTreeDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  classificationGetClassificationsAsFlatList(
    body: GetClassificationsRequest | undefined
  ): Promise<ClassificationDto[][]> {
    let url_ = this.baseUrl + "/v1/Classification/GetClassificationsAsFlatList";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processClassificationGetClassificationsAsFlatList(_response);
      });
  }

  protected processClassificationGetClassificationsAsFlatList(response: Response): Promise<ClassificationDto[][]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationDto[][]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationGetClassifications(body: GetClassificationRequest | undefined): Promise<ClassificationDto> {
    let url_ = this.baseUrl + "/admin/v1/Classification/GetClassifications";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationGetClassifications(_response);
      });
  }

  protected processAdmin_ClassificationGetClassifications(response: Response): Promise<ClassificationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ClassificationDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationPatchClassification(id: number, body: PatchClassificationRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/Classification/{id}/classification";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationPatchClassification(_response);
      });
  }

  protected processAdmin_ClassificationPatchClassification(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  admin_ClassificationDeleteClassification(id: number): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/Classification/{id}/classification";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationDeleteClassification(_response);
      });
  }

  protected processAdmin_ClassificationDeleteClassification(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationPostClassification(body: PostClassificationRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/admin/v1/Classification/postclassification";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationPostClassification(_response);
      });
  }

  protected processAdmin_ClassificationPostClassification(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationPatchClassificationMove(body: PatchClassificationMoveRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/admin/v1/Classification/patchclassificationmove";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationPatchClassificationMove(_response);
      });
  }

  protected processAdmin_ClassificationPatchClassificationMove(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @return Success
   */
  classificationRootGetClassificationRoots(): Promise<ClassificationRootDto[]> {
    let url_ = this.baseUrl + "/v1/ClassificationRoot/GetClassificationRoots";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processClassificationRootGetClassificationRoots(_response);
      });
  }

  protected processClassificationRootGetClassificationRoots(response: Response): Promise<ClassificationRootDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClassificationRootDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationRootDto[]>(null as any);
  }

  /**
   * @return Success
   */
  admin_ClassificationRootGetClassificationRoots(): Promise<ClassificationRootDto[]> {
    let url_ = this.baseUrl + "/admin/v1/ClassificationRoot/GetClassificationRoots";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationRootGetClassificationRoots(_response);
      });
  }

  protected processAdmin_ClassificationRootGetClassificationRoots(
    response: Response
  ): Promise<ClassificationRootDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClassificationRootDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationRootDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationRootPostClassificationRoot(body: PostClassificationRootRequest | undefined): Promise<boolean> {
    let url_ = this.baseUrl + "/admin/v1/ClassificationRoot/PostClassificationRoot";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationRootPostClassificationRoot(_response);
      });
  }

  protected processAdmin_ClassificationRootPostClassificationRoot(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_ClassificationRootPatchClassificationRoot(
    id: number,
    body: PatchClassificationRootRequest | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/ClassificationRoot/{id}/classificationroot";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationRootPatchClassificationRoot(_response);
      });
  }

  protected processAdmin_ClassificationRootPatchClassificationRoot(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  admin_ClassificationRootDeleteClassification(id: number): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/ClassificationRoot/{id}/classificationroot";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationRootDeleteClassification(_response);
      });
  }

  protected processAdmin_ClassificationRootDeleteClassification(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  admin_ClassificationTypeGetAllClassificationTypes(): Promise<ClassificationTypeDto[]> {
    let url_ = this.baseUrl + "/admin/v1/ClassificationType/GetAllClassificationTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_ClassificationTypeGetAllClassificationTypes(_response);
      });
  }

  protected processAdmin_ClassificationTypeGetAllClassificationTypes(
    response: Response
  ): Promise<ClassificationTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClassificationTypeDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClassificationTypeDto[]>(null as any);
  }

  /**
   * @return Success
   */
  admin_CustomerGetAllCustomers(): Promise<CustomerDto[]> {
    let url_ = this.baseUrl + "/admin/v1/Customer/GetAllCustomers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_CustomerGetAllCustomers(_response);
      });
  }

  protected processAdmin_CustomerGetAllCustomers(response: Response): Promise<CustomerDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(CustomerDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomerDto[]>(null as any);
  }

  /**
   * @return Success
   */
  health(): Promise<void> {
    let url_ = this.baseUrl + "/v1/Health";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHealth(_response);
      });
  }

  protected processHealth(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param metaDataId (optional)
   * @return Success
   */
  admin_MetaDataGetMetaData(metaDataId: number | undefined): Promise<MetaDataDto> {
    let url_ = this.baseUrl + "/admin/v1/MetaData/GetMetaDataAsync?";
    if (metaDataId === null) throw new Error("The parameter 'metaDataId' cannot be null.");
    else if (metaDataId !== undefined) url_ += "metaDataId=" + encodeURIComponent("" + metaDataId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_MetaDataGetMetaData(_response);
      });
  }

  protected processAdmin_MetaDataGetMetaData(response: Response): Promise<MetaDataDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MetaDataDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MetaDataDto>(null as any);
  }

  /**
   * @param classificationId (optional)
   * @return Success
   */
  admin_MetaDataGetMetaDatas(classificationId: number | undefined): Promise<MetaDataDto> {
    let url_ = this.baseUrl + "/admin/v1/MetaData/GetMetaDatasAsync?";
    if (classificationId === null) throw new Error("The parameter 'classificationId' cannot be null.");
    else if (classificationId !== undefined)
      url_ += "classificationId=" + encodeURIComponent("" + classificationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_MetaDataGetMetaDatas(_response);
      });
  }

  protected processAdmin_MetaDataGetMetaDatas(response: Response): Promise<MetaDataDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MetaDataDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MetaDataDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_MetaDataPatchMetaData(id: number, body: PatchMetaDataRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/MetaData/{id}/metadata";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_MetaDataPatchMetaData(_response);
      });
  }

  protected processAdmin_MetaDataPatchMetaData(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  admin_MetaDataDeleteMetaData(id: number): Promise<void> {
    let url_ = this.baseUrl + "/admin/v1/MetaData/{id}/metadata";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_MetaDataDeleteMetaData(_response);
      });
  }

  protected processAdmin_MetaDataDeleteMetaData(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  admin_MetaDataPostMetaData(body: PostMetaDataRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/admin/v1/MetaData/postmetadata";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_MetaDataPostMetaData(_response);
      });
  }

  protected processAdmin_MetaDataPostMetaData(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @return Success
   */
  admin_StateGetAllStates(): Promise<StateDto[]> {
    let url_ = this.baseUrl + "/admin/v1/State/getallstates";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAdmin_StateGetAllStates(_response);
      });
  }

  protected processAdmin_StateGetAllStates(response: Response): Promise<StateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(StateDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<StateDto[]>(null as any);
  }
}

export class GetClassificationRequest implements IGetClassificationRequest {
  classificationId?: number;
  cultureName?: string;
  includeDescendants?: boolean;

  constructor(data?: IGetClassificationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationId = _data["classificationId"];
      this.cultureName = _data["cultureName"];
      this.includeDescendants = _data["includeDescendants"];
    }
  }

  static fromJS(data: any): GetClassificationRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetClassificationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["classificationId"] = this.classificationId;
    data["cultureName"] = this.cultureName;
    data["includeDescendants"] = this.includeDescendants;
    return data;
  }
}

export interface IGetClassificationRequest {
  classificationId?: number;
  cultureName?: string;
  includeDescendants?: boolean;
}

export class PatchClassificationMoveRequest implements IPatchClassificationMoveRequest {
  sourceClassificationId?: number;
  destinationClassificationId?: number;
  action?: number;

  constructor(data?: IPatchClassificationMoveRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sourceClassificationId = _data["sourceClassificationId"];
      this.destinationClassificationId = _data["destinationClassificationId"];
      this.action = _data["action"];
    }
  }

  static fromJS(data: any): PatchClassificationMoveRequest {
    data = typeof data === "object" ? data : {};
    let result = new PatchClassificationMoveRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sourceClassificationId"] = this.sourceClassificationId;
    data["destinationClassificationId"] = this.destinationClassificationId;
    data["action"] = this.action;
    return data;
  }
}

export interface IPatchClassificationMoveRequest {
  sourceClassificationId?: number;
  destinationClassificationId?: number;
  action?: number;
}

export class PatchClassificationRequest implements IPatchClassificationRequest {
  stateId?: number;
  textDtos?: TextDto[];

  constructor(data?: IPatchClassificationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.stateId = _data["stateId"];
      if (Array.isArray(_data["textDtos"])) {
        this.textDtos = [] as any;
        for (let item of _data["textDtos"]) this.textDtos!.push(TextDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PatchClassificationRequest {
    data = typeof data === "object" ? data : {};
    let result = new PatchClassificationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["stateId"] = this.stateId;
    if (Array.isArray(this.textDtos)) {
      data["textDtos"] = [];
      for (let item of this.textDtos) data["textDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPatchClassificationRequest {
  stateId?: number;
  textDtos?: TextDto[];
}

export class PostClassificationRequest implements IPostClassificationRequest {
  parentClassificationId?: number;
  stateId?: number;
  textDtos?: TextDto[];

  constructor(data?: IPostClassificationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentClassificationId = _data["parentClassificationId"];
      this.stateId = _data["stateId"];
      if (Array.isArray(_data["textDtos"])) {
        this.textDtos = [] as any;
        for (let item of _data["textDtos"]) this.textDtos!.push(TextDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PostClassificationRequest {
    data = typeof data === "object" ? data : {};
    let result = new PostClassificationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["parentClassificationId"] = this.parentClassificationId;
    data["stateId"] = this.stateId;
    if (Array.isArray(this.textDtos)) {
      data["textDtos"] = [];
      for (let item of this.textDtos) data["textDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPostClassificationRequest {
  parentClassificationId?: number;
  stateId?: number;
  textDtos?: TextDto[];
}

export class PatchClassificationRootRequest implements IPatchClassificationRootRequest {
  customerId?: string;
  typeId?: number;
  name?: string;
  description?: string | undefined;

  constructor(data?: IPatchClassificationRootRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerId = _data["customerId"];
      this.typeId = _data["typeId"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PatchClassificationRootRequest {
    data = typeof data === "object" ? data : {};
    let result = new PatchClassificationRootRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerId"] = this.customerId;
    data["typeId"] = this.typeId;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IPatchClassificationRootRequest {
  customerId?: string;
  typeId?: number;
  name?: string;
  description?: string | undefined;
}

export class PostClassificationRootRequest implements IPostClassificationRootRequest {
  classificationId?: number;
  customerId?: string;
  typeId?: number;
  name?: string;
  description?: string | undefined;

  constructor(data?: IPostClassificationRootRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationId = _data["classificationId"];
      this.customerId = _data["customerId"];
      this.typeId = _data["typeId"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PostClassificationRootRequest {
    data = typeof data === "object" ? data : {};
    let result = new PostClassificationRootRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["classificationId"] = this.classificationId;
    data["customerId"] = this.customerId;
    data["typeId"] = this.typeId;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IPostClassificationRootRequest {
  classificationId?: number;
  customerId?: string;
  typeId?: number;
  name?: string;
  description?: string | undefined;
}

export class GetClassificationsRequest implements IGetClassificationsRequest {
  classificationIds?: string[];
  includeDescendants?: boolean;
  cultureName?: string;

  constructor(data?: IGetClassificationsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["classificationIds"])) {
        this.classificationIds = [] as any;
        for (let item of _data["classificationIds"]) this.classificationIds!.push(item);
      }
      this.includeDescendants = _data["includeDescendants"];
      this.cultureName = _data["cultureName"];
    }
  }

  static fromJS(data: any): GetClassificationsRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetClassificationsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.classificationIds)) {
      data["classificationIds"] = [];
      for (let item of this.classificationIds) data["classificationIds"].push(item);
    }
    data["includeDescendants"] = this.includeDescendants;
    data["cultureName"] = this.cultureName;
    return data;
  }
}

export interface IGetClassificationsRequest {
  classificationIds?: string[];
  includeDescendants?: boolean;
  cultureName?: string;
}

export class PatchMetaDataRequest implements IPatchMetaDataRequest {
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;

  constructor(data?: IPatchMetaDataRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationId = _data["classificationId"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): PatchMetaDataRequest {
    data = typeof data === "object" ? data : {};
    let result = new PatchMetaDataRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["classificationId"] = this.classificationId;
    data["name"] = this.name;
    data["type"] = this.type;
    data["value"] = this.value;
    return data;
  }
}

export interface IPatchMetaDataRequest {
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;
}

export class PostMetaDataRequest implements IPostMetaDataRequest {
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;

  constructor(data?: IPostMetaDataRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationId = _data["classificationId"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): PostMetaDataRequest {
    data = typeof data === "object" ? data : {};
    let result = new PostMetaDataRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["classificationId"] = this.classificationId;
    data["name"] = this.name;
    data["type"] = this.type;
    data["value"] = this.value;
    return data;
  }
}

export interface IPostMetaDataRequest {
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;
}

export class ClassificationDto implements IClassificationDto {
  id?: number;
  parentId?: number | undefined;
  nodeId?: HierarchyId;
  identifier?: string;
  parentIdentifier?: string | undefined;
  stateDto?: StateDto | undefined;
  name?: string | undefined;
  description?: string | undefined;
  help?: string | undefined;
  customer?: string | undefined;
  texts?: TextDto[];
  children?: ClassificationDto[] | undefined;

  constructor(data?: IClassificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.parentId = _data["parentId"];
      this.nodeId = _data["nodeId"] ? HierarchyId.fromJS(_data["nodeId"]) : <any>undefined;
      this.identifier = _data["identifier"];
      this.parentIdentifier = _data["parentIdentifier"];
      this.stateDto = _data["stateDto"] ? StateDto.fromJS(_data["stateDto"]) : <any>undefined;
      this.name = _data["name"];
      this.description = _data["description"];
      this.help = _data["help"];
      this.customer = _data["customer"];
      if (Array.isArray(_data["texts"])) {
        this.texts = [] as any;
        for (let item of _data["texts"]) this.texts!.push(TextDto.fromJS(item));
      }
      if (Array.isArray(_data["children"])) {
        this.children = [] as any;
        for (let item of _data["children"]) this.children!.push(ClassificationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClassificationDto {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["parentId"] = this.parentId;
    data["nodeId"] = this.nodeId ? this.nodeId.toJSON() : <any>undefined;
    data["identifier"] = this.identifier;
    data["parentIdentifier"] = this.parentIdentifier;
    data["stateDto"] = this.stateDto ? this.stateDto.toJSON() : <any>undefined;
    data["name"] = this.name;
    data["description"] = this.description;
    data["help"] = this.help;
    data["customer"] = this.customer;
    if (Array.isArray(this.texts)) {
      data["texts"] = [];
      for (let item of this.texts) data["texts"].push(item.toJSON());
    }
    if (Array.isArray(this.children)) {
      data["children"] = [];
      for (let item of this.children) data["children"].push(item.toJSON());
    }
    return data;
  }
}

export interface IClassificationDto {
  id?: number;
  parentId?: number | undefined;
  nodeId?: HierarchyId;
  identifier?: string;
  parentIdentifier?: string | undefined;
  stateDto?: StateDto | undefined;
  name?: string | undefined;
  description?: string | undefined;
  help?: string | undefined;
  customer?: string | undefined;
  texts?: TextDto[];
  children?: ClassificationDto[] | undefined;
}

export class ClassificationRootDto implements IClassificationRootDto {
  classificationId?: number;
  name?: string;
  description?: string | undefined;
  typeId?: number;
  classificationDto?: ClassificationDto;
  classificationTypeDto?: ClassificationTypeDto;
  customerDto?: CustomerDto | undefined;

  constructor(data?: IClassificationRootDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationId = _data["classificationId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.typeId = _data["typeId"];
      this.classificationDto = _data["classificationDto"]
        ? ClassificationDto.fromJS(_data["classificationDto"])
        : <any>undefined;
      this.classificationTypeDto = _data["classificationTypeDto"]
        ? ClassificationTypeDto.fromJS(_data["classificationTypeDto"])
        : <any>undefined;
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ClassificationRootDto {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationRootDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["classificationId"] = this.classificationId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["typeId"] = this.typeId;
    data["classificationDto"] = this.classificationDto ? this.classificationDto.toJSON() : <any>undefined;
    data["classificationTypeDto"] = this.classificationTypeDto ? this.classificationTypeDto.toJSON() : <any>undefined;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IClassificationRootDto {
  classificationId?: number;
  name?: string;
  description?: string | undefined;
  typeId?: number;
  classificationDto?: ClassificationDto;
  classificationTypeDto?: ClassificationTypeDto;
  customerDto?: CustomerDto | undefined;
}

export class ClassificationTreeDto implements IClassificationTreeDto {
  id?: number;
  nodeId?: HierarchyId;
  identifier?: string;
  name?: string | undefined;
  items?: ClassificationTreeDto[] | undefined;

  constructor(data?: IClassificationTreeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.nodeId = _data["nodeId"] ? HierarchyId.fromJS(_data["nodeId"]) : <any>undefined;
      this.identifier = _data["identifier"];
      this.name = _data["name"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items!.push(ClassificationTreeDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClassificationTreeDto {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationTreeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["nodeId"] = this.nodeId ? this.nodeId.toJSON() : <any>undefined;
    data["identifier"] = this.identifier;
    data["name"] = this.name;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IClassificationTreeDto {
  id?: number;
  nodeId?: HierarchyId;
  identifier?: string;
  name?: string | undefined;
  items?: ClassificationTreeDto[] | undefined;
}

export class ClassificationTypeDto implements IClassificationTypeDto {
  id?: number;
  type?: string;

  constructor(data?: IClassificationTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): ClassificationTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["type"] = this.type;
    return data;
  }
}

export interface IClassificationTypeDto {
  id?: number;
  type?: string;
}

export class CustomerDto implements ICustomerDto {
  id?: string;
  name?: string;

  constructor(data?: ICustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CustomerDto {
    data = typeof data === "object" ? data : {};
    let result = new CustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface ICustomerDto {
  id?: string;
  name?: string;
}

export class MetaDataDto implements IMetaDataDto {
  id?: number;
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;

  constructor(data?: IMetaDataDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.classificationId = _data["classificationId"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): MetaDataDto {
    data = typeof data === "object" ? data : {};
    let result = new MetaDataDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["classificationId"] = this.classificationId;
    data["name"] = this.name;
    data["type"] = this.type;
    data["value"] = this.value;
    return data;
  }
}

export interface IMetaDataDto {
  id?: number;
  classificationId?: number;
  name?: string;
  type?: string;
  value?: string;
}

export class StateDto implements IStateDto {
  id?: number;
  name?: string;

  constructor(data?: IStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): StateDto {
    data = typeof data === "object" ? data : {};
    let result = new StateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IStateDto {
  id?: number;
  name?: string;
}

export class TextDto implements ITextDto {
  id?: number;
  value?: string;
  cultureName?: string;
  textType?: number;

  constructor(data?: ITextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.value = _data["value"];
      this.cultureName = _data["cultureName"];
      this.textType = _data["textType"];
    }
  }

  static fromJS(data: any): TextDto {
    data = typeof data === "object" ? data : {};
    let result = new TextDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["value"] = this.value;
    data["cultureName"] = this.cultureName;
    data["textType"] = this.textType;
    return data;
  }
}

export interface ITextDto {
  id?: number;
  value?: string;
  cultureName?: string;
  textType?: number;
}

export class HierarchyId implements IHierarchyId {
  constructor(data?: IHierarchyId) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): HierarchyId {
    data = typeof data === "object" ? data : {};
    let result = new HierarchyId();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

export interface IHierarchyId {}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
